import { money } from "@/lib/scoring";
import { CountUp } from "./CountUp";
import { Badge } from "./Badge";
import { displayName } from "@/data/nicknames";

const MEDAL = [
  { ring: "border-cypress-gold", text: "text-cypress-gold", glow: "shadow-[0_0_36px_rgba(201,162,39,0.28)]" },
  { ring: "border-[#C9CDD3]/70", text: "text-[#C9CDD3]", glow: "shadow-[0_0_24px_rgba(201,205,211,0.15)]" },
  { ring: "border-[#C77B3F]/70", text: "text-[#C77B3F]", glow: "shadow-[0_0_24px_rgba(199,123,63,0.15)]" },
];

const PodiumCard = ({ player, place, big = false, badges, onSelect }) => {
  const m = MEDAL[place];
  return (
    <button
      type="button"
      data-testid={`podium-card-${place + 1}`}
      onClick={() => onSelect(player.name)}
      className={`flex w-full flex-col items-center rounded-xl border ${m.ring} bg-gradient-to-b from-cypress-green/70 to-cypress-night px-4 ${
        big ? "py-6 sm:py-8" : "py-5"
      } text-center ${m.glow} transition-transform duration-300 hover:-translate-y-1`}
    >
      <span className={`font-mono font-bold ${m.text} ${big ? "text-3xl" : "text-2xl"}`}>{place + 1}</span>
      <span className={`mt-1 font-semibold tracking-tight ${big ? "text-lg" : "text-base"}`}>{displayName(player.name)}</span>
      {badges.length > 0 && (
        <span className="mt-2 flex flex-wrap justify-center gap-1">
          {badges.map((b) => (
            <Badge key={b} type={b} />
          ))}
        </span>
      )}
      <span className={`mt-2 font-mono font-bold text-cypress-gold ${big ? "text-3xl" : "text-2xl"}`}>
        <CountUp value={player.totalWon} format={(v) => money(v)} />
      </span>
    </button>
  );
};

export const Podium = ({ players, badgesFor, onSelect }) => {
  if (players.length < 3) return null;
  const [first, second, third] = players;
  return (
    <div className="mt-6 grid grid-cols-1 gap-3 sm:grid-cols-3 sm:items-end" data-testid="podium">
      <div className="sm:order-2">
        <PodiumCard player={first} place={0} big badges={badgesFor(first)} onSelect={onSelect} />
      </div>
      <div className="sm:order-1">
        <PodiumCard player={second} place={1} badges={badgesFor(second)} onSelect={onSelect} />
      </div>
      <div className="sm:order-3">
        <PodiumCard player={third} place={2} badges={badgesFor(third)} onSelect={onSelect} />
      </div>
    </div>
  );
};
